<template>
  <div class="full" >
    <div id="map" class="full"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'GoogleMap',
  computed: {
    ...mapState(['DepLatLng', 'search', 'dropDestionaton'])
  },
  data () {
    return {
      mapName: 'map',
      element: null,
      latlng: null,
      mapOptions: null,
      map: null,
      routeMarkers: []
    }
  },
  methods: {
    ...mapMutations([
      'loadingEnd',
      'setOriginalApiData',
      'setSelectedSpot',
      'setLastRoute',
      'loadingStartMini',
      'loadingEndMini'
    ]),
    /**
     * マップのロード
     */
    loadMap () {
      this.element = document.getElementById(this.mapName)
      this.latlng = new window.google.maps.LatLng(36.65, 138.180)
      this.mapOptions = {
        zoom: 12,
        center: this.latlng,
        gestureHandling: 'greedy',
        scaleControl: false,
        mapTypeControl: false,
        zoomControl: true,
        streetViewControl: false,
        fullscreenControl: false
      }
      this.map = new window.google.maps.Map(this.element, this.mapOptions)
      const trafficLayer = new window.google.maps.TrafficLayer()
      trafficLayer.setMap(this.map)
      this.loadingEnd()
    },
    setDefaultMarker (position) {
      let marker = new window.google.maps.Marker({
        position,
        map: this.map
      })
      this.routeMarkers.push(marker)
    },
    convertStartTime () {
      const time = new RegExp('([0-9]{2})', 'g')
      let parsedString = this.search.departureTime.match(time)
      var now = new Date()
      var dt = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parsedString[0], parsedString[1], now.getMinutes())

      return dt
    },
    searchRoute () {
      this.setDefaultMarker(this.DepLatLng)
      this.setDefaultMarker(this.dropDestionaton.latlng)
      let loadingEndMini = this.loadingEndMini
      var directionsService = new window.google.maps.DirectionsService()
      let setLastRoute = this.setLastRoute
      var directionsDisplay = new window.google.maps.DirectionsRenderer({
        map: this.map,
        suppressMarkers: true
      })
      directionsService.route({
        origin: this.DepLatLng,
        destination: this.dropDestionaton.latlng,
        travelMode: window.google.maps.TravelMode.DRIVING,
        drivingOptions: {
          departureTime: this.convertStartTime(),
          trafficModel: 'bestguess'
        }
      }, function (response, status) {
        if (status === window.google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response)
          setLastRoute(response)
        }
        loadingEndMini()
      })
    }
  },
  mounted () {
    this.loadingStartMini()
    this.loadMap()
  },
  watch: {
    map: {
      immideate: true,
      handler: function () {
        this.searchRoute()
      }
    }
  }
}
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100px;
  margin: 0 auto;
  background: gray;
}
.full{
  width:100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/GoogleMapOnlyResult.vue